import { tv } from "tailwind-variants";

export const getBadgeClass = tv({
  base: "inline-flex w-fit items-center rounded-5xl border transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
  variants: {
    variant: {
      default: "border-transparent bg-[#EFF2F6]",
      white: "border-transparent bg-white",
      primary: "border-transparent bg-primary text-primary-foreground",
      secondary: "border-transparent bg-secondary-100 text-primary-500",
      destructive: "border-transparent bg-destructive text-destructive-foreground",
      outline: "text-foreground",
      outlinePrimary: "border-primary text-primary",
    },
    size: {
      base: "px-4 py-2 font-semibold text-[13px] lg:text-sm",
      xs: "px-2 font-semibold text-[13px] lg:text-sm",
      xl: "px-4 py-1.5 font-semibold text-base leading-normal",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "base",
  },
});
